module.exports = __webpack_public_path__ + "static/media/testimonial-lindsay-foster.ea6433b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/testimonial-lindsay-foster.jpg
// module id = 401
// module chunks = 0